import {
  get
} from '../axios'

class GlobParam {
  async getTrade(param) {
    const res = await get('/GlobalParam/GetTrade', param)
    return res
  }
  async getSource(param) {
    const res = await get('/GlobalParam/GetSource', param)
    return res
  }
  async getNationality(param) {
    const res = await get('/GlobalParam/GetNationality', param)
    return res
  }
  async getCompanyType(param) {
    const res = await get('/GlobalParam/GetCompanyType', param)
    return res
  }
  async getGetSex(param) {
    const res = await get('/GlobalParam/GetSex', param)
    return res
  }
  async getGetJobStatus(param) {
    const res = await get('/GlobalParam/GetJobStatus', param)
    return res
  }
  async getGetCard(param) {
    const res = await get('/GlobalParam/GetCard', param)
    return res
  }
  async getCustType(param) {
    const res = await get('/GlobalParam/GetCustType', param)
    return res
  }
  async getVisitWay(param) {
    const res = await get('/GlobalParam/GetVisitWay', param)
    return res
  }
  async getVisitReason(param) {
    const res = await get('/GlobalParam/GetVisitReason', param)
    return res
  }
  async getClueStatus(param) {
    const res = await get('/GlobalParam/GetClueStatus', param)
    return res
  }
}
export default new GlobParam()